import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DialogComponent,
  Spinner,
  TabsComponent,
  UploaderComponent,
} from '../../../../../Components';
import 'react-quill/dist/quill.snow.css';
import {
  GetParams,
  showError,
  showSuccess,
  showWarn,
} from '../../../../../Helper';
import {
  ImagesGalleryFilterEnum,
  UploaderThemesEnum,
} from '../../../../../Enums';
import { DetailsComponentTabsData } from '../DetailsComponentTabsData';
import { TabelSubCommunitiesRelated } from '../../LocationSharingUtilities';
import { ImagesGalleryPhotosCardComponent } from '../../LocationSharingUtilities/ImagesGalleryPhotosCardComponent/ImagesGalleryPhotosCardComponent';
import {
  CreateOrUpdateLocationLookupAlbum,
  DeleteAlbumImage,
  GetAllImagesByTypeId,
} from '../../../../../Services';

export const EditFormCommunity = ({ parentTranslationPath }) => {
  const { t } = useTranslation(parentTranslationPath);
  const [filter] = useState({
    pageSize: 1000,
    pageIndex: 0,
    search: '',
  });
  const [state, setState] = useState({
    lookupItemId: 0,
    arabicLocationName: '',
    LocationName: '',
    files: '',
    isActive: true,
    logImage: '',
    masterPlan: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setisOpen] = useState(false);
  const [item, setitem] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [cityPhotos, setCityPhotos] = useState({
    result: [],
    totalCount: 0,
  });
  const onTabChanged = (e, newTap) => {
    setActiveTab(newTap);
  };
  const getAllCityPhotos = useCallback(async () => {
    const res = await GetAllImagesByTypeId({
      ...filter,
      lookupItemId: +GetParams('id'),
      typeId: ImagesGalleryFilterEnum.Community.key,
    });
    if (!(res && res.status && res.status !== 200)) {
      setCityPhotos({
        result: res.result,
        totalCount: res.totalCount,
      });
    } else showError(t('permission'));
  });

  const deleteHandler = async (ImageId) => {
    setIsLoading(true);
    const res = ImageId?.albumImagesId
      ? await DeleteAlbumImage(ImageId?.albumImagesId)
      : null;
    if (!(res && res.status && res.status !== 200)) {
      getAllCityPhotos();
      const newList =
        state?.logImage !== '' && Array.isArray(state.logImage)
          ? state.logImage.filter((f) => f.fileId !== (res && res.fileId))
          : [];
      setState((items) => ({
        ...items,
        logImage: [...newList] || [],
      }));
      setIsLoading(false);
      showSuccess(t('image-delete-successfully'));
    } else showError(t('image-delete-failed'));
    setisOpen(false);
    setIsLoading(false);
  };

  const saveHandler = async (imagesToUpload = []) => {
    if (imagesToUpload.length === 0) return;
    setIsLoading(true);

    const toSaveState = {
      imageGalleryType: ImagesGalleryFilterEnum.Community.lookupType,
      lookupItemId: +GetParams('id'),
      albumImages: imagesToUpload,
    };
    const res = await CreateOrUpdateLocationLookupAlbum(toSaveState);
    setIsLoading(false);
    if (!(res && res.data && res.data.ErrorId)) {
      if (res) {
        showSuccess(t('image-upload-successfully'));
        getAllCityPhotos();
      } else showError(t('image-upload-failed'));
    }
  };
  useEffect(() => {
    getAllCityPhotos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='view-wrapper-editFormCountry'>
      <div className='d-flex-column'>
        <div className='UploaderComponent-wrapered pt-4'>
          <div className='mt-2 mb-2'>
            <span className='fw-bold'>{`${t('community-logo')}`}</span>
          </div>
          <UploaderComponent
            idRef='profileLogoRef'
            uploaderTheme={UploaderThemesEnum.box.key}
            defaultImage='Uploadmark'
            WithoutDefaultImg
            multiple={false}
            dropHereText='Drag-and-drop-here-or-browse-File'
            uploadedChanged={(files) => {
              if (
                state.logImage !== '' &&
                state.logImage &&
                Array.isArray(state.logImage) &&
                state.logImage.length > 0
              ) {
                showWarn(
                  t('please-remove-logo-image-before-add-new-logo-image')
                );
                return;
              } else if (
                cityPhotos?.result &&
                cityPhotos.result.some((s) => s.isLogo)
              ) {
                showWarn(
                  t('please-remove-logo-image-before-add-new-logo-image')
                );
                return;
              }
              const newLogo = {
                isLogo: true,
                fileId: (files.length > 0 && files[0].uuid) || null,
                fileName: (files.length > 0 && files[0].fileName) || null,
              };
              setState((items) => ({
                ...items,
                logImage: [newLogo],
              }));
              saveHandler([newLogo]);
            }}
          />
          <ImagesGalleryPhotosCardComponent
            data={cityPhotos?.result?.filter((f) => f.isLogo) || []}
            WithCheckbox
            Selectedvalue={(items) => {}}
            deletevalue={(items) => {
              setitem(items);
              setisOpen(true);
            }}
          />
        </div>
        <div className='UploaderComponent-wrapered pt-4'>
          <div className='mt-2 mb-2'>
            <span className='fw-bold'> {`${t('community-images')}`} </span>
          </div>
          <UploaderComponent
            idRef='profileImgRef'
            uploaderTheme={UploaderThemesEnum.box.key}
            defaultImage='Uploadmark'
            WithoutDefaultImg
            dropHereText='Drag-and-drop-here-or-browse-File'
            multiple={false}
            initUploadedFiles={
              (state.templateFileId && [
                {
                  uuid: state.templateFileId,
                  fileName: state.templateFileName,
                },
              ]) ||
              []
            }
            uploadedChanged={(files) => {
              const newImage = {
                fileId: (files.length > 0 && files[0].uuid) || null,
                fileName: (files.length > 0 && files[0].fileName) || null,
              };

              setState((items) => ({
                ...items,
                files: [newImage],
              }));
              saveHandler([newImage]);
            }}
          />
        </div>
        <div className='pt-4'>
          <ImagesGalleryPhotosCardComponent
            data={
              cityPhotos?.result?.filter(
                (item) => !item.isLogo && !item.isPlan
              ) || []
            }
            WithCheckbox
            Selectedvalue={(items) => {}}
            deletevalue={(items) => {
              setitem(items);
              setisOpen(true);
            }}
          />
        </div>

        <div className='UploaderComponent-wrapered pt-4'>
          <div className='mt-2 mb-2'>
            <span className='fw-bold'>
              {`${t('community-master-plan-image')}`}
            </span>
          </div>
          <UploaderComponent
            idRef='masterPlanImgRef'
            uploaderTheme={UploaderThemesEnum.box.key}
            defaultImage='Uploadmark'
            WithoutDefaultImg
            dropHereText='Drag-and-drop-here-or-browse-File'
            multiple={false}
            uploadedChanged={(files) => {
              const newImage = {
                isPlan: true,
                fileId: files.length > 0 && files[0].uuid,
                fileName: files.length > 0 && files[0].fileName,
              };
              setState((items) => ({
                ...items,
                masterPlan: [newImage],
              }));
              saveHandler([newImage]);
            }}
          />
        </div>
        <div className='pt-4'>
          <ImagesGalleryPhotosCardComponent
            data={cityPhotos?.result?.filter((item) => item.isPlan) || []}
            WithCheckbox
            Selectedvalue={(items) => {}}
            deletevalue={(items) => {
              setitem(items);
              setisOpen(true);
            }}
          />
        </div>
        <DialogComponent
          titleText='confirm-message'
          saveText='confirm'
          saveType='button'
          maxWidth='sm'
          dialogContent={
            <div className='d-flex-column-center'>
              <Spinner
                isActive={isLoading}
                isAbsolute
              />
              <span className='mdi mdi-close-octagon c-danger mdi-48px' />
              <span>{`${t('ConfirmText')}`}</span>
            </div>
          }
          saveClasses='btns theme-solid bg-danger w-100 mx-2 mb-2'
          isOpen={isOpen}
          onSaveClicked={() => deleteHandler(item)}
          onCloseClicked={() => {
            setisOpen(false);
          }}
          onCancelClicked={() => {
            setisOpen(false);
          }}
          parentTranslationPath={parentTranslationPath}
        />

        <div className='w-100 pt-4'>
          <TabsComponent
            data={DetailsComponentTabsData}
            labelInput='tab'
            parentTranslationPath={parentTranslationPath}
            themeClasses='theme-curved'
            currentTab={activeTab}
            onTabChanged={onTabChanged}
          />
          {activeTab === 0 && (
            <div>
              <TabelSubCommunitiesRelated
                parentTranslationPath={parentTranslationPath}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
